import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { SingleImageDropzone } from "../DropzoneComponents";   // <-- yolu düzelt
import { toast } from "react-toastify";

const COVER_W = 120;   // kırpılacak genişlik
const COVER_H = 120;   // kırpılacak yükseklik

const InstitutionCreate = () => {
  const [formData, setFormData] = useState({
    title: "",
    city: "",
    district: "",
    cover: null,
    slogan: "",
  });
  const navigate = useNavigate();

  /* —— text alanları —— */
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  /* —— SingleImageDropzone’a geçici “birleştirici” setter —— */
  const mergeCover = (payload) => {
    setFormData((prev) => {
      if (typeof payload === "function") return { ...prev, ...payload(prev) };
      if (payload && typeof payload === "object") return { ...prev, ...payload };
      // payload direkt File ise:
      return { ...prev, cover: payload };
    });
  };

  /* —— submit —— */
const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const token = localStorage.getItem("admin_token");
    const fd = new FormData();
    fd.append("title", formData.title);
    fd.append("city", formData.city);
    fd.append("district", formData.district);
    fd.append("slogan", formData.slogan);
    if (formData.cover) fd.append("cover", formData.cover);

    await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/institution/create`,
      fd,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    toast.success("Kurum başarıyla eklendi.");
    setTimeout(() => {
      navigate("/institutions/table");
    }, 1500); // 1.5 saniye sonra yönlendir

  } catch (err) {
    console.error("❌ Kurum eklenemedi:", err);
    toast.error("Kayıt sırasında bir hata oluştu.");
  }
};

  /* —— UI —— */
  return (
    <div className="container mt-4">
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="card p-4 shadow-sm mb-4">
          <h4 className="mb-3 fw-bold">Kurum Bilgileri</h4>

          {[
            ["title", "Başlık", true],
            ["city", "İl", true],
            ["district", "İlçe", true],
            ["slogan", "Slogan", false],
          ].map(([field, label, req]) => (
            <div className="mb-3" key={field}>
              <label className="form-label fw-bold">{label}</label>
              <input
                type="text"
                className="form-control"
                name={field}
                value={formData[field]}
                onChange={handleInputChange}
                required={req}
              />
            </div>
          ))}

          {/* ---- Görsel ---- */}
          <div className="mb-3">
            <label className="form-label fw-bold">
              Görsel ({COVER_W}×{COVER_H})
            </label>

            <SingleImageDropzone
              fieldName="cover"
              fieldValue={formData.cover}
              setFieldValues={mergeCover}
              required
              maxWidth={COVER_W}
              maxHeight={COVER_H}
            />
          </div>

          <div className="d-flex justify-content-center">
            <button type="submit" className="btn btn-primary">
              Kaydet
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default InstitutionCreate;
